const About = () => {
  const metricsCategories = [
    {
      title: 'Standard',
      metrics: ['BLEU', 'chrF++', 'TER', 'WER', 'hLEPOR'],
    },
    {
      title: 'BERTScore family',
      metrics: ['BERTScore (base)', 'BERTScore (Large)', 'BERTScore (XL)', 'BERTScore (XXL)'],
    },
    {
      title: 'COMET family',
      metrics: ['COMET', 'XCOMET-XL', 'XCOMET-XXL', 'COMETKiwi', 'COMETKiwi-XL', 'COMETKiwi-XXL'],
    },
    {
      title: 'Google / MetricX family',
      metrics: ['MetricX-24 Hybrid XXL'],
    },
  ];

  return (
    <div className="w-full flex items-center justify-center">
      <div className="md:max-w-[1400px] w-full py-8 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_1.4fr] gap-6">
          <div className="rounded-xl border border-[#E2E8F0] bg-white p-6">
            <div className="inline-flex items-center px-2.5 py-1 rounded-full bg-[#EEF2FF] text-[#1E3A8A] text-xs font-semibold">
              How Metrics Work
            </div>
            <h3 className="text-2xl font-semibold text-[#0F172A] mt-3">Understand quality at a glance</h3>
            <p className="text-sm text-[#6B7280] mt-2">
              Combine classical and neural metrics to measure accuracy, fluency, and overall translation quality.
            </p>
            <div className="mt-5 space-y-3 text-sm text-[#6B7280]">
              <div className="flex gap-3">
                <span className="h-2 w-2 mt-2 rounded-full bg-[#60A5FA]" />
                <span>Upload source, target, and reference texts.</span>
              </div>
              <div className="flex gap-3">
                <span className="h-2 w-2 mt-2 rounded-full bg-[#34D399]" />
                <span>Run multiple metrics in parallel for a balanced view.</span>
              </div>
              <div className="flex gap-3">
                <span className="h-2 w-2 mt-2 rounded-full bg-[#FBBF24]" />
                <span>Compare systems and spot quality gaps quickly.</span>
              </div>
            </div>
          </div>

          <div className="rounded-xl border border-[#E2E8F0] bg-white p-6">
            <div className="inline-flex items-center px-2.5 py-1 rounded-full bg-[#EEF2FF] text-[#1E3A8A] text-xs font-semibold">
              Metrics catalog
            </div>
            <h4 className="text-2xl font-semibold text-[#0F172A] mt-3">Browse metrics by family</h4>
            <p className="text-sm text-[#6B7280] mt-2">
              Each family focuses on a different aspect of quality, from classic scores to neural models.
            </p>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {metricsCategories.map((category) => (
                <div key={category.title} className="rounded-lg border border-[#E2E8F0] bg-[#F8FAFC] p-3">
                  <h5 className="text-xs font-semibold uppercase tracking-wide text-[#94A3B8] mb-2">
                    {category.title}
                  </h5>
                  <ul className="space-y-1">
                    {category.metrics.map((metric) => (
                      <li className="text-sm text-[#6B7280]" key={metric}>{metric}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
